import script from "./jlrwtj.vue?vue&type=script&setup=true&lang=ts"
export * from "./jlrwtj.vue?vue&type=script&setup=true&lang=ts"

import "./jlrwtj.vue?vue&type=style&index=0&id=050f4438&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050f4438"]])

export default __exports__